/**
 * This component renders a card with a link to a club page on the All Clubs page
 * TODO In future this will move to its own folder when varsity is added
 */

import React from "react";
import { Link } from "react-router-dom";
// import ImageContainer from "./ImageContainer";

const LinkCard = ({ link, name, img, rink, col1, col2 }) => {
  const bgStyle = {
    background: `linear-gradient(to right, ${col1}, ${col2})`,
    opacity: 0.9,
  };

  return (
    <Link
      to={`/club/${link}`}
      className="group flex flex-col justify-start items-center border-2 border-light-3 dark:border-dark-2 rounded h-28 xl:h-32 max-xxs:w-[95px] xxs:w-[120px] xs:w-[200px] xl:w-[230px] my-1 lg:my-2 mx-1 lg:mx-2"
    >
      <div className="flex h-2 xs:h-14 xl:h-20 w-full relative bg-cover bg-center">
        <div className="absolute top-0 left-0 h-full w-full bg-gradient-to-r dark:opacity-30" style={bgStyle}></div>

        {/* Adjusted image container to support scaling */}
        <div className="relative flex justify-center items-center w-full h-full">
          <img
            className="hidden xs:flex xl:h-12 xl:w-12 h-10 w-10 transition-transform duration-300 ease-in-out group-hover:scale-110"
            src={img}
            alt={name}
          />
        </div>
      </div>

      <div className="flex flex-col items-center justify-center h-28 xs:h-20">
        {/* Hidden image for smaller screens */}
        <img
          className="xs:hidden flex xxs:h-10 xxs:w-10 w-8 h-8 mb-1 transition-transform duration-300 ease-in-out group-hover:scale-110"
          src={img}
          alt={name}
        />

        {/* Club name with hover color change */}
        <h2 className="px-1 xxs:px-2 text-xs max-xs:text-xxs text-center leading-tight transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
          {name}
        </h2>

        {/* Ice Rink text */}
        <p className="hidden xs:flex text-xxs font-light text-center text-darken pt-1 leading-tight">
          {rink}
        </p>
      </div>
    </Link>
  );
};

export default LinkCard;

/* with rink image

<Link to={link} className="flex flex-col justify-start items-center bg-dark-4 rounded h-36 w-56 mb-4 mx-2">
  <div 
    className="hidden lg2:flex h-20 w-full relative bg-cover bg-center" 
    style={{
      backgroundImage: "url('https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fdesignshack.net%2Fwp-content%2Fuploads%2Fplacehold.jpg&f=1&nofb=1&ipt=82db825f9bfdbd4d9d830f0c656334f16a0cf4a6950a812db7d1b4473848bbe0&ipo=images')"
    }}
  >
    <div className="absolute top-0 left-0 h-full w-full bg-gradient-to-r from-red-500 via-black to-blue-500 opacity-50 "></div>
    
    <ImageContainer 
      src={`https://buiha.org.uk/assets/img/rink/${name.split(' ')[0].toLowerCase()}.jpg`} 
      alt={""} 
      className="relative z-20"
    />

    <img
      className="h-12 w-12"
      src={img}
      alt={name}
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 30,
      }}
    />
  </div>
  <div className="flex flex-col justify-center items-center h-16 w-full">
    <h2 className="text-lg text-center font-semibold">{name}</h2>
  </div>
</Link>
*/
